import moment from 'moment'

var field = {
  width: '100px',
  display: 'inline-block',
  paddingRight: '6px',
  textAlign: 'left'
}

var DEFAULT_FORM_VALUES = {
  communicationID: 0,
  mailingTypeID: 0,
  isLegalCommunication: false,
  description: '',
  compositionMethod: '',
  htmlContent: '',
  documentID: 0,
  mailingID: 0,
  isSaveUpdated: false
}

export const data = () => ({
  formComplete: false,
  formData: {
    ...DEFAULT_FORM_VALUES
  },
  loading: true,
  isDebug: true,
  isReadOnly: false,
  mailingTypeList: [],
  descriptionIsStarted: false,
  wasAdded: false,

  formatDateFn: function(value) {
    return value && value != undefined
      ? moment(value.toString(), 'YYYY/MM/DD HH:mm:ss')
          .format('MM-DD-YYYY')
          .toString()
      : ''
  },
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    },
    amountField: Object.assign({}, field, {
      width: '125px'
    })
  }
})
